export default __webpack_public_path__ + "static/media/nespresso.c3e44888.svg";